export default function useInjectAd (stream: any, adConfig: any, section: string) {
  if (stream.length > 0) {
    const streamAds = adConfig?.[section]?.stream || [];
    if (streamAds.length > 0) {
      let adsInserted = 0; // Counter for injected ads
      for (const streamAd of streamAds) {
        let adPosition = streamAd?.index?.[getDeviceType()];

        // Adjust position to account for already inserted ads
        adPosition += adsInserted;

        if (adPosition <= stream.length && adPosition >= 0) {
          stream.splice(adPosition, 0, streamAd);
          adsInserted++; // Increment the counter after injecting an ad
        }
      }
    }
  }
  return stream;
}
